import React, { useId } from 'react';
import { useFormContext } from 'react-hook-form';

import { cn } from '@epoch-ui/lib/utils';
import {
  ActionButtonGroup,
  ActionButtonGroupItem,
  ActionButtonGroupItemIcon,
  ActionButtonGroupItemLabel,
  ActionButtonGroupItemCaption
} from '@epoch-ui/components/ActionButtonGroup';

import {
  FormField,
  FormControl,
  FormDescription,
  FormLabel,
  FormItem,
  FormMessage
} from '../../form';

export interface ActionButtonGroupFieldProps
  extends React.ComponentPropsWithRef<typeof ActionButtonGroup> {
  name: string;
  label?: string | React.ReactNode | React.ReactNode[];
  description?: string | React.ReactNode | React.ReactNode[];
}

export const ActionButtonGroupField: React.FC<ActionButtonGroupFieldProps> = ({
  name,
  label,
  description,
  className,
  ...props
}) => {
  const formCtx = useFormContext();
  const id = useId();

  return (
    <FormField
      control={formCtx.control}
      name={name || id}
      render={({ field }): React.ReactElement => (
        <FormItem>
          {label && (
            <FormLabel className={cn('tw-mb-0', props.disabled && 'tw-opacity-40')}>
              {label}
            </FormLabel>
          )}
          {description && (
            <FormDescription className={cn('tw-m-0', props.disabled && 'tw-opacity-40')}>
              {description}
            </FormDescription>
          )}
          <FormControl className="tw-mt-2">
            <ActionButtonGroup
              ref={field.ref}
              name={field.name}
              value={field.value ?? ''}
              onValueChange={field.onChange}
              className={className}
              {...props}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export {
  ActionButtonGroupItem,
  ActionButtonGroupItemIcon,
  ActionButtonGroupItemLabel,
  ActionButtonGroupItemCaption
};
